var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.1909 24.6396C8.07995 24.6396 2.88328 18.3935 2.66675 8H7.23056C7.38047 15.6286 10.745 18.8599 13.41 19.5261V8H17.7074V14.5792C20.3391 14.2961 23.1037 11.2979 24.0365 8H28.3339C27.6177 12.0641 24.6195 15.0623 22.4875 16.2948C24.6195 17.2942 28.0342 19.9092 29.3334 24.6396H24.6029C23.5868 21.4749 21.0553 19.0264 17.7074 18.6933V24.6396H17.1909Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVk);
export default __webpack_public_path__ + "static/media/vk.6da54c35919e4078d5f57e73ecad9697.svg";
export { ForwardRef as ReactComponent };